import * as busyCounter from '../../../shared/action-creators/busy-counter';
import RgaBOReportRequest from '../state/rga-BO-report-request';
import {getFileName} from '../../../shared/services/get-file-name';
import {getRgaDownloadReport} from '../../shared/repositories';
import {openFile} from '../../../shared/services/open-file';
import {successAlertBar} from '../../../shared/services/alert-bar';
import {translate} from '../../../shared/services/translation-service';

function buildPaylod(selectedDataTypes, registrationDate, responsibleUnit) {

    return new RgaBOReportRequest({
        additionalDataTypes: selectedDataTypes.map(dataType => dataType.value),
        requestDateFrom: registrationDate.from,
        requestDateTo: registrationDate.to,
        responsibleUnit: responsibleUnit ? responsibleUnit : ''
    });

}

export const downloadRga = (selectedDataTypes, registrationDate, responsibleUnit) =>

        async dispatch => {

            dispatch(busyCounter.increaseBusyCounter());

            try {

                const payload = buildPaylod(selectedDataTypes, registrationDate, responsibleUnit);

                const response = await getRgaDownloadReport(payload);

                const fileName = getFileName(response);

                const blob = await response.blob();

                openFile(blob, fileName, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');

                successAlertBar(translate('Report downloaded successfully'));

            } catch (error) {
            } finally {

                dispatch(busyCounter.decreaseBusyCounter());

            }

        };



// WEBPACK FOOTER //
// ./src/rga/reports/action-creators/rga-download.js